const addBrowserOsClasses = () => {
  const agent = navigator.userAgent;
  let browser = '';
  let os = '';

  // browsers
  if (/Gecko/i.test(agent)) {
    if (/Firefox/i.test(agent)) {
      browser = 'browser-firefox';
    }
  }

  // OS
  if (/Windows NT/.test(agent)) {
    os = 'os-windows';
  }

  angular.element('body').addClass(browser).addClass(os);
  angular.element('body').attr('style', '');
};

const run = () => {
  'ngInject';
  addBrowserOsClasses();
};

export default run;
